import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/rosadominga.png";
import Imagen2 from "../../../images/modulo12/congresistas.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad8 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[10];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[11].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[11].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[9].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[9].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
          <h2 className="mb-4">Un lento avance</h2>

            <p>
              Poco a poco se han ido logrando{" "}
              <strong>avances para las mujeres</strong> en nuestro país. Las
              mujeres fueron conquistando sus derechos para participar de
              ciertos espacios que eran solo para hombres. Por ejemplo, en 1908
              se dio la ley que permitía a las mujeres{" "}
              <strong>ir a la universidad</strong>. En 1920, Rosa Dominga Pérez
              se convirtió en la primera mujer en recibir un título de abogada.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              La lucha para que las mujeres puedan <strong>votar</strong> se
              inicia en 1914 gracias a María Jesús Alvarado. También se lucha
              para lograr mejores condiciones en el <strong>trabajo</strong>. En
              1950 ya había muchas mujeres en trabajos importantes.
            </p>
            <p>
              En 1955, se otorgó el voto a las mujeres, quienes votaron por
              primera vez en las elecciones de 1956. Ese año se eligió a la
              primera senadora y a la primera diputada.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Léalo en voz alta y comente que, a lo largo de los años, se han
            logrado ciertos avances para lograr la igualdad de las mujeres.
            Pregunte cuáles son los avances que se mencionan en el texto. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  “En el texto se menciona la asistencia a la universidad y por
                  lo tanto la titulación de profesionales mujeres; el voto;
                  mejoras de condiciones laborales y la presencia de las mujeres
                  en la política”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
